module.exports = __webpack_public_path__ + "img/logo.d6ab042c.png";